/**
 * Check whether the country is valid or not
 * Checks: the length of string should be 2 and the string should be in upper case
 * @param country
 * @returns whether country is valid
 */
export const isValidCountry = (country: string) => {
  return /^[A-Z]{2}$/g.test(country);
};
